import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class UsuarioProfileForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      nombre: ['required'],
      email: ['required', 'email']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data = {} } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Nombre"
          name="nombre"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.nombre }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Email"
          name="email"
          placeholder="email@example.com"
          help=""
          validator={ validator }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default UsuarioProfileForm;